import { ReactNode } from 'react'
import styles from '@/app/_components/EventDetails/EventDetails.module.css'
import { buildMapUrl } from '@/utils/urls.utils'
import { getEventMeta, handleVenueMeta } from '@/utils/events.utils'
import { useEvent, useEventVenue } from '@/app/_providers/EventProvider/EventProvider'
import TXT from '@/messages'

const VenueAddress = (): ReactNode => {
  const eventVenue = useEventVenue()
  const primaryEventData = useEvent<Transformed.EventWithTimeslotsAndMeta>()
  const meta = getEventMeta(primaryEventData.meta)
  const { venueAddress } = handleVenueMeta(meta, eventVenue)

  if (!venueAddress) {
    return null
  }

  return (
    <>
      <div>
        {venueAddress}
      </div>
      <div className={styles.EventMapLink}>
        <a
          href={buildMapUrl(venueAddress)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {TXT.buttons.viewMap}
        </a>
      </div>
    </>
  )
}

export default VenueAddress
